import { PublicLayout } from "@/components/PublicLayout";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-4 py-12 text-center">
        <h1 className="font-display text-5xl text-primary">Contact Us</h1>
        <p className="mt-4 text-lg text-slate-600">
          We'd love to hear from you! Get in touch with any questions about our classes.
        </p>
        <div className="grid sm:grid-cols-2 gap-6 mt-12 text-left">
          <a href="tel:07977440009" data-testid="contact-phone"
            className="rounded-3xl bg-white border border-border p-8 hover:shadow-xl hover:-translate-y-1 transition-all flex items-center gap-4">
            <div className="rounded-2xl bg-primary/10 p-4"><Phone className="text-primary" /></div>
            <div>
              <div className="font-display text-xl text-slate-800">Phone</div>
              <div className="text-slate-600">07977 440 009</div>
            </div>
          </a>
          <a href="mailto:admin@fun-nastix.co.uk" data-testid="contact-email"
            className="rounded-3xl bg-white border border-border p-8 hover:shadow-xl hover:-translate-y-1 transition-all flex items-center gap-4">
            <div className="rounded-2xl bg-secondary/10 p-4"><Mail className="text-secondary" /></div>
            <div>
              <div className="font-display text-xl text-slate-800">Email</div>
              <div className="text-slate-600">admin@fun-nastix.co.uk</div>
            </div>
          </a>
        </div>
        <div className="rounded-3xl bg-primary/5 border border-border p-8 mt-6 flex items-center justify-center gap-3 text-slate-700">
          <MapPin className="text-primary" /> Serving schools across Southampton
        </div>
      </div>
    </PublicLayout>
  );
}
